import type { Role } from '@getcircuit/schema'

import type { ClientContext, ErrorResponse, SuccessResponse } from '../../types'

type CreateMemberResponse =
  | SuccessResponse<{
      errors: undefined | null
      id: string
    }>
  | ErrorResponse<{
      existingMember: string
      email: string
    }>

/**
 * Documentation:
 * https://www.notion.so/circuit/B2B-Firebase-Functions-b98eb289350e4c3ea9115fe5d2c9e677#d3dd882430ee4846acc5ebfc1b48431f
 * */
export function createMember(
  context: ClientContext,
  {
    name,
    email,
    phone,
    roles,
    teamId,
  }: {
    name?: string
    email?: string
    phone?: string
    roles: Role[]
    teamId: string
  },
): Promise<CreateMemberResponse> {
  return context.request(`/teams/${teamId}/members`, {
    method: 'POST',
    withAuth: true,
    json: {
      name,
      email,
      phone,
      roles,
    },
  })
}

/**
 * Documentation: https://www.notion.so/circuit/B2B-Firebase-Functions-b98eb289350e4c3ea9115fe5d2c9e677#b5d11c487d8945d1b01dbefd40b7bf9d
 * */
export function activateUser(
  context: ClientContext,
  {
    memberId,
    teamId,
  }: {
    memberId: string
    teamId: string
  },
) {
  return context.request(`/teams/${teamId}/members/${memberId}/activate`, {
    method: 'POST',
    withAuth: true,
  })
}
